interface Resource {
  id: string;
  title: string;
  url: string | null;
  note: string | null;
  pinned_at: number;
}

interface Props {
  resources: Resource[];
  canPin: boolean;
}

/**
 * Typographic list of pinned resources. Avoid card-grid styling that reads
 * as a "links board".
 */
export function PinnedResources({ resources, canPin }: Props) {
  if (resources.length === 0) {
    return (
      <div className="panel p-6">
        <p className="label-eyebrow">Pinned</p>
        <p className="mt-3 text-sm text-whisper leading-relaxed">
          Resources will be pinned here by your circle leader.
        </p>
        {canPin && (
          <button
            type="button"
            disabled
            title="Pin editor lands in Phase 7"
            className="mt-5 text-[10px] uppercase tracking-[0.18em] text-muted disabled:cursor-not-allowed"
          >
            Pin resource — coming soon
          </button>
        )}
      </div>
    );
  }
  return (
    <div className="panel p-6">
      <p className="label-eyebrow">Pinned</p>
      <ul className="mt-4 space-y-3">
        {resources.map((r) => (
          <li key={r.id} className="border-l-2 border-veil/40 pl-3">
            <div className="font-display text-sm leading-snug">
              {r.url ? (
                <a
                  href={r.url}
                  target="_blank"
                  rel="noreferrer"
                  className="hover:text-gold-glow transition-colors"
                >
                  {r.title}
                </a>
              ) : (
                r.title
              )}
            </div>
            {r.note && (
              <p className="mt-1 text-xs text-whisper leading-relaxed">{r.note}</p>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
}
